import React from 'react';
import { Command } from 'cmdk';

export function StyledCommandItem({
  children,
  ...props
}: { children: React.ReactNode } & React.ComponentProps<typeof Command.Item>) {
  return (
    <Command.Item
      className="group cursor-pointer rounded-lg px-2 py-2 text-sm text-gray-700 data-[selected=true]:bg-gray-100 dark:text-gray-200 dark:data-[selected=true]:bg-white/5"
      {...props}
    >
      <div className="flex items-center justify-between">{children}</div>
    </Command.Item>
  );
}
